import ModalDeleteFilled from '../../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalDeleteCreditorContactPersonProps extends ModalEditComponentProps { }

const ModalDeleteCreditorContactPerson: React.FC<ModalDeleteCreditorContactPersonProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()

    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/supplier/supplierContactPerson/updateSupplierContactPerson',
        data: {
            id: allRowData?.id,
            name: allRowData?.name,
            active: false,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteContactPerson', '¿Seguro que quieres eliminar este contacto?'),
            subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminado no podrás recuperarlo')
        }} />
    )
}

export default ModalDeleteCreditorContactPerson